export const APPNAME = 'RSL TESTING';
export const LOGGEDTEXT = 'Logged in User : ';
